type SuccessfulNonRecurrent = {
  startDate: string
  endDate: string
}

type NonRecurrentInterval = {
  start_date: string
  end_date: string
}

export type SelectedNonRecurrentReservationPair = {
  interval: NonRecurrentInterval
  restrictionDate: Date | string
}

export function buildSelectedNonRecurrentReservationPairs(
  reservationDateStrings: (string | null | undefined)[],
  restrictionDates: Array<Date | string | null | undefined>
): SelectedNonRecurrentReservationPair[] {
  const pairs: SelectedNonRecurrentReservationPair[] = []
  reservationDateStrings.forEach((dateString, index) => {
    if (!dateString) return
    const restrictionDate = restrictionDates[index]
    if (restrictionDate == null) return
    const startDate = new Date(dateString)
    const endDate = new Date(startDate)
    endDate.setMinutes(startDate.getMinutes() + 59)
    endDate.setSeconds(startDate.getSeconds() + 59)
    pairs.push({
      interval: {
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
      },
      restrictionDate,
    })
  })
  return pairs
}


export type ReservationCheckoutExceptionItem = {
  exceptionDateIso: string
  replacementStartIso: string
}

export function toReservationCheckoutExceptions(
  restrictionDates: Array<Date | string> | null | undefined,
  successfulNonRecurrentReservations: SuccessfulNonRecurrent[] | undefined
): ReservationCheckoutExceptionItem[] | undefined {
  if (!successfulNonRecurrentReservations?.length) return undefined
  return successfulNonRecurrentReservations.map((confirmedInterval, restrictionIndex) => ({
    exceptionDateIso:
      restrictionDates != null && restrictionDates[restrictionIndex] != null
        ? new Date(restrictionDates[restrictionIndex] as Date | string).toISOString()
        : confirmedInterval.startDate,
    replacementStartIso: confirmedInterval.startDate,
  }))
}
